import { SET_GLOBAL_REPORT } from '../actions';
import { reduxStoreTypes } from '@type/redux-store';

const globalReport = (globalReport:boolean = false, action: reduxStoreTypes.GlobalReportAction) => {
    if (action.type === SET_GLOBAL_REPORT) {
        return action.globalReport
    }
    return globalReport
}
export default globalReport